import { render, staticRenderFns } from "./Artifacts.vue?vue&type=template&id=10aab28f&lang=pug&"
import script from "./Artifacts.vue?vue&type=script&lang=ts&"
export * from "./Artifacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports